import containerFuild from '../html-snippets/container-fuild';
import css from '../css-snippets/section-feetscare-list-image';

const html = `
<div class="wrap-card container">
  <div data-show="true" data-attribute="card-title" class="card-title">
    <h2 style="text-align: center;">AS SEEN IN</h2>
  </div>
  <div class="list-item-image" data-attribute="list-item-image" data-width-image="100px" style="--width-image: 100px">
    <div class="wrap-img-item" data-attribute="item-image">
      <img class="img-item" data-attribute="img-item" src="https://cdn.skyfastimg.com/images/2026/08/25/image-6a8cfb63ac9b9f9ff60b9166.png" alt="">
    </div>
    <div class="wrap-img-item" data-attribute="item-image">
      <img class="img-item" data-attribute="img-item" src="https://cdn.skyfastimg.com/images/2026/08/25/image-6a8cfbb8318ec41bb9937caa.png" alt="">
    </div>
    <div class="wrap-img-item" data-attribute="item-image">
      <img class="img-item" data-attribute="img-item" src="https://cdn.skyfastimg.com/images/2026/08/25/image-6a8cfb63ac9b9f9ff60b9166.png" alt="">
    </div>
    <div class="wrap-img-item" data-attribute="item-image">
      <img class="img-item" data-attribute="img-item" src="https://cdn.skyfastimg.com/images/2026/08/25/image-6a8cfbd172a9e890127961e0.png" alt="">
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#dc9376',
  textColor: '#FFFFFF',
});
